<!--<c-footer>-->
<div>
  <span>&copy; {{ currentYear }}</span>
  <a href="https://www.iiitb.ac.in/" target="_blank"> IIIT Bangalore.</a>
  <span> All Rights Reserved</span>
</div>
<!--</c-footer>-->